// extracted by mini-css-extract-plugin
export default {"gainfulbutton":"BJ","borderRadius":"CJ","disabled":"EJ","widthFourty":"FJ","widthSixty":"GJ","fullwidth":"HJ","accountEditSubscriptionBtn":"IJ","accountRdBtn":"JJ","accountProductBtn":"KJ","accountBannerBtn":"LJ","upProductTopBanner":"MJ","upProductGainfulTile":"NJ","disabledBtn":"OJ","buttonsmall":"PJ","buttonlarge":"QJ","buttonxlarge":"RJ","high":"SJ"};
    if(module.hot) {
      // 1713211521454
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  